export enum SeitenlokalisationDisplayNameEnum {
  Links = 'links',
  Beidseitig = 'beidseitig',
  Rechts = 'rechts',
  KeineAuswahl = 'keine Auswahl',
}
